import React from 'react';
import { CpuIcon, TrendingUpIcon, CrosshairIcon } from 'lucide-react';
export function MechanismSection() {
  return <section className="w-full py-24 px-4 bg-brand-bg relative overflow-hidden" data-id="element-147">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-brand-gold/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-148" />

      <div className="max-w-5xl mx-auto text-center space-y-12 relative z-10" data-id="element-149">
        <div className="space-y-4" data-id="element-150">
          <h2 className="text-4xl md:text-5xl text-brand-gold" data-id="element-151">
            La Ingeniería Inversa de Cuotas
          </h2>
          <p className="text-xl text-brand-text max-w-3xl mx-auto leading-relaxed" data-id="element-152">
            Esto no es un libro de predicciones ni picks mágicos. Es un sistema
            paso a paso para entender cómo funcionan las cuotas… y encontrar
            oportunidades donde otros solo ven riesgo.
          </p>
        </div>

        <div className="bg-brand-card border border-brand-gold/20 rounded-2xl p-8 md:p-12 shadow-[0_10px_30px_rgba(0,0,0,0.5)]" data-id="element-153">
          <p className="text-lg md:text-xl text-brand-muted leading-relaxed mb-10" data-id="element-154">
            Vas a aprender a identificar cuándo la casa de apuestas se equivoca
            y cómo aprovechar esas oportunidades con lógica, no con suerte.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-155">
            <div className="flex flex-col items-center text-center space-y-4" data-id="element-156">
              <div className="w-16 h-16 rounded-full bg-brand-alt border border-brand-gold/30 flex items-center justify-center" data-id="element-157">
                <CpuIcon className="w-8 h-8 text-brand-gold" data-id="element-158" />
              </div>
              <h3 className="text-xl text-brand-text" data-id="element-159">📊 DATOS REALES</h3>
              <p className="text-brand-faint text-sm" data-id="element-160">
                Deja de mirar solo resultados. Aprende a interpretar
                estadísticas que realmente importan (como xG).
              </p>
            </div>

            <div className="flex flex-col items-center text-center space-y-4" data-id="element-161">
              <div className="w-16 h-16 rounded-full bg-brand-alt border border-brand-gold/30 flex items-center justify-center" data-id="element-162">
                <TrendingUpIcon className="w-8 h-8 text-brand-gold" data-id="element-163" />
              </div>
              <h3 className="text-xl text-brand-text" data-id="element-164">📈 VALOR DE MERCADO</h3>
              <p className="text-brand-faint text-sm" data-id="element-165">
                Descubre cuándo una cuota está mal calculada… y dónde está la
                ventaja.
              </p>
            </div>

            <div className="flex flex-col items-center text-center space-y-4" data-id="element-166">
              <div className="w-16 h-16 rounded-full bg-brand-alt border border-brand-gold/30 flex items-center justify-center" data-id="element-167">
                <CrosshairIcon className="w-8 h-8 text-brand-gold" data-id="element-168" />
              </div>
              <h3 className="text-xl text-brand-text" data-id="element-169">🧠 CONTEXTO REAL</h3>
              <p className="text-brand-faint text-sm" data-id="element-170">
                Lesiones, motivación, fatiga… factores que la mayoría ignora y
                que cambian todo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}